/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_User_Groups_Members_CountInputs */

const en_tables_user_groups_members_count = /** @type {(inputs: Tables_User_Groups_Members_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groups Members Count`)
};

const de_tables_user_groups_members_count = /** @type {(inputs: Tables_User_Groups_Members_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Gruppenmitglieder`)
};

/**
* | output |
* | --- |
* | "Groups Members Count" |
*
* @param {Tables_User_Groups_Members_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_user_groups_members_count = /** @type {((inputs?: Tables_User_Groups_Members_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_User_Groups_Members_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_user_groups_members_count(inputs)
	return de_tables_user_groups_members_count(inputs)
});